// Country code to name mapping - now using translation keys
// This includes standard ISO2 codes and special codes (xb, xt, xs)
export const COUNTRY_NAMES: Record<string, string> = {
  // Europe
  'ad': 'countries.ad',
  'al': 'countries.al',
  'at': 'countries.at',
  'ba': 'countries.ba',
  'be': 'countries.be',
  'bg': 'countries.bg',
  'by': 'countries.by',
  'ch': 'countries.ch',
  'ci': 'countries.ci',
  'cy': 'countries.cy',
  'cz': 'countries.cz',
  'de': 'countries.de',
  'dk': 'countries.dk',
  'dz': 'countries.dz',
  'ee': 'countries.ee',
  'es': 'countries.es',
  'fi': 'countries.fi',
  'fr': 'countries.fr',
  'gb': 'countries.gb',
  'gi': 'countries.gi',
  'gr': 'countries.gr',
  'hr': 'countries.hr',
  'hu': 'countries.hu',
  'ie': 'countries.ie',
  'is': 'countries.is',
  'it': 'countries.it',
  'lt': 'countries.lt',
  'lu': 'countries.lu',
  'lv': 'countries.lv',
  'ma': 'countries.ma',
  'md': 'countries.md',
  'me': 'countries.me',
  'mg': 'countries.mg',
  'mk': 'countries.mk',
  'mt': 'countries.mt',
  'mu': 'countries.mu',
  'nl': 'countries.nl',
  'no': 'countries.no',
  'pl': 'countries.pl',
  'pt': 'countries.pt',
  'ro': 'countries.ro',
  'rs': 'countries.rs',
  'ru': 'countries.ru',
  'se': 'countries.se',
  'si': 'countries.si',
  'sk': 'countries.sk',
  'sn': 'countries.sn',
  'tn': 'countries.tn',
  'tr': 'countries.tr',
  'ua': 'countries.ua',
  'za': 'countries.za',
  
  // Americas
  'ca': 'countries.ca',
  'cl': 'countries.cl',
  'mx': 'countries.mx',
  'us': 'countries.us',
  'pe': 'countries.pe',
  
  // Asia
  'ae': 'countries.ae',
  'au': 'countries.au',
  'bh': 'countries.bh',
  'cn': 'countries.cn',
  'hk': 'countries.hk',
  'id': 'countries.id',
  'il': 'countries.il',
  'in': 'countries.in',
  'ir': 'countries.ir',
  'jp': 'countries.jp',
  'kr': 'countries.kr',
  'kz': 'countries.kz',
  'lb': 'countries.lb',
  'lk': 'countries.lk',
  'mn': 'countries.mn',
  'mo': 'countries.mo',
  'my': 'countries.my',
  'nz': 'countries.nz',
  'pk': 'countries.pk',
  'qa': 'countries.qa',
  'sg': 'countries.sg',
  'th': 'countries.th',
  'tw': 'countries.tw',
  'vn': 'countries.vn',
  'sa': 'countries.sa',
  'ph': 'countries.ph',
  
  // Special codes
  'xb': 'countries.xb',
  'xt': 'countries.xt',
  'xs': 'countries.xs'
};

// Function to get country name by code - returns translation key
export const getCountryName = (code: string): string => {
  return COUNTRY_NAMES[code.toLowerCase()] || code.toUpperCase();
};

// Function to check if a code is a special code
export const isSpecialCode = (code: string): boolean => {
  return ['xb', 'xt', 'xs'].includes(code.toLowerCase());
};
